var map = {
	"./17-cn.webp": 1164,
	"./17.webp": 1165,
	"./27-cn.webp": 1166,
	"./27.webp": 1167,
	"./7-cn.webp": 1168,
	"./7.webp": 1169,
	"./angpao-bg-mobile.jpg": 1170,
	"./angpao-bg.jpg": 1171,
	"./angpao-cn.webp": 1172,
	"./angpao.webp": 1173,
	"./button.png": 1174,
	"./close-eye.png": 1175,
	"./coin-1.png": 1176,
	"./coin.png": 1177,
	"./ketupak-open.png": 1178,
	"./ketupak.png": 1179,
	"./ketupak_ribbon.png": 1180,
	"./rain-1.png": 1181,
	"./rain-2.png": 1182,
	"./rain-3.png": 1183,
	"./raya-bg-mobile.png": 1184,
	"./raya-bg.png": 1185,
	"./shine.png": 1186,
	"./star-1.png": 1187,
	"./star-2.png": 1188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 456;